const TWO_MINUTES_IN_MILLISECONDS = 60 * 1000 * 2;

export { TWO_MINUTES_IN_MILLISECONDS };
